export default "__VITE_ASSET__Ca_1wdha__"